import { Link } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/material/Tabs";
import TabPanel from "@mui/lab/TabPanel";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import { useNavigate } from "react-router-dom";
import { Box, Button, TextField } from "@mui/material";
import {
  boxStyle,
  buttonPosition,
  form_add,
  buttonStyle,
} from "../../style/style";
import { useState } from "react";
import DistributorProfile from "./DistributorProfile";
import DistributorUserList from "./DistributorUserList";
import { Dialog } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AddDistributorUser from "./AddDistributorUser";
import FormControl from "@mui/material/FormControl";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { postobj } from "../../apicall/apicall";
import { validated } from "../../apicall/validateform";

export default function DistributorSetting(props) {
  const [value, setvalue] = useState("1");
  const [open, setopen] = useState(false);
  const [pwdchange, setpwdchange] = useState(false);
  const [password, setpassword] = useState({
    old_password: "",
    new_password: "",
  });
  const [pwd2, setpwd2] = useState();
  const history = useNavigate();

  const handleChange = (val) => {
    //props.search.setsearch("");
    setvalue(val);
  };

  const handlepassword = (e) => {
    const { name, value } = e.target;
    setpassword({
      ...password,
      [name]: value,
    });
  };
  const handlePasswordChange = () => {
    if (validated(password)) {
      if (password.new_password !== password.old_password) {
        if (pwd2 === password.new_password) {
          const url = process.env.REACT_APP_ZEWA_URL + "user/reset-password/";
          const res = postobj(url, password);
          res.then(function (r) {
            if (r["Message"] === "Password changed successfully") {
              NotificationManager.success("Password Changed.", "Success", 2000);
              NotificationManager.remove(NotificationManager.listNotify[0]);
              sessionStorage.setItem("token", "");
              history({ pathname: "/" });
              window.location.reload(true);
            } else {
              NotificationManager.remove(NotificationManager.listNotify[0]);

              NotificationManager.error("Incorrect password", "Failed", 2000);
              reset();
              setopen(false);
            }
          });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Password did not match", "Failed", 2000);
          reset();
          setopen(false);
        }
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "New password cant not be same as old password"
        );
      }
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error(
        "Please fill the form correctly",
        "Failed",
        2000
      );
    }
  };
  const reset = () => {
    setpassword({
      old_password: "",
      new_password: "",
    });
    setpwd2("");
    setpwdchange(false);
  };

  return (
    <div>
      <TabContext value={value}>
        <Box sx={boxStyle}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              //onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Profile"
                value={"1"}
                onClick={() => handleChange("1")}
              />
              <Tab
                label="Users"
                value={"2"}
                onClick={() => handleChange("2")}
              />
            </Tabs>
          </Box>
        </Box>
        <TabPanel value={"1"}>
          <Box>
            <DistributorProfile
              distributor={props.distributor}
              refresh={props.refresh}
              setrefresh={props.setrefresh}
            />

            <Link
              href="#"
              variant="body2"
              sx={{ padding: "10px" }}
              onClick={(e) => {
                e.preventDefault();

                console.log(pwdchange);
                setpwdchange(true);
              }}
            >
              Change password
            </Link>
          </Box>
        </TabPanel>
        <TabPanel value={"2"}>
          <div>
            <Box
              m={2}
              sx={buttonPosition}
              //margin
            >
              <Button
                variant={"contained"}
                color={"primary"}
                startIcon={<AddToQueueIcon />}
                onClick={() => {
                  setopen(true);
                }}
              >
                {value === "2" ? "add User" : "Add Organization"}
              </Button>
            </Box>
            <DistributorUserList
              id={props.distributor.customer_id["id"]}
              search={{ search: props.search }}
              setrefresh={props.setrefresh}
              refresh={props.refresh}
            />
          </div>
          <Dialog
            open={open}
            onClose={() => {
              setopen(false);
            }}
          >
            <AddDistributorUser
              setadduser={setopen}
              id={props.distributor.customer_id.id}
              setrefresh={props.setrefresh}
              refresh={props.refresh}
            />
          </Dialog>
        </TabPanel>
      </TabContext>
      <Dialog
        open={pwdchange}
        onClose={() => {
          setpwdchange(false);
        }}
      >
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <TextField
              name="old_password"
              sx={form_add}
              type="password"
              label="Enter Old Password"
              variant="standard"
              value={password.old_password}
              onChange={handlepassword}
            />
            <TextField
              name="new_password"
              sx={form_add}
              type="password"
              label="Enter New Password"
              variant="standard"
              value={password.new_password}
              onChange={handlepassword}
            />
            <TextField
              name="New Password"
              sx={form_add}
              type="password"
              label="Re-enter New Password"
              variant="standard"
              value={pwd2}
              onChange={(e) => {
                setpwd2(e.target.value);
              }}
            />
            <Box m={1} sx={{ marginLeft: "-10px" }}>
              <Button
                color="primary"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={handlePasswordChange}
              >
                Change
              </Button>
              <Button
                color="error"
                variant="contained"
                className="form__custom-button"
                sx={buttonStyle}
                type="submit"
                onClick={reset}
              >
                Cancel
              </Button>
            </Box>
          </FormControl>
        </DialogContent>
      </Dialog>
      <NotificationContainer />
    </div>
  );
}
